(function () {
    'use strict';

    a3_cabin_reports.directive('requestForm', requestForm);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name requestForm
    * @restrict E
    * @description
    *   Crew Table with a double row per crew member
    * @example
    *   Usage:
    *   <request-form request-type="Ground Duty" ></request-form>
    *   <request-form request-type="Flight" ></request-form>
    * @ngInject
    */
    function requestForm() {
        function link(scope, attrs) {
        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/RosterRequests/requestForm.html',
            scope: false,
            link: link
        }
    }

})();